import { render } from "./DraftFooter.vue?vue&type=template&id=1bf71b0b&scoped=true"
import script from "./DraftFooter.vue?vue&type=script&lang=js"
export * from "./DraftFooter.vue?vue&type=script&lang=js"

import "./DraftFooter.vue?vue&type=style&index=0&id=1bf71b0b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf71b0b"]])

export default __exports__